"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findOrCreateAccountByMint = exports.createUninitializedMiningAccount = exports.createUninitializedObligationAccount = exports.getOrCreateAssociatedTokenAccount = exports.createUninitializedAccount = exports.ensureSplAccount = void 0;
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const models_1 = require("../models");
const config_1 = require("../config/config");
const mining_1 = require("../models/state/mining");
function ensureSplAccount(instructions, cleanupInstructions, toCheck, payer, amount, signers) {
    if (!toCheck.info.isNative) {
        return toCheck.pubkey;
    }
    const account = createUninitializedAccount(instructions, payer, amount, signers);
    instructions.push(spl_token_1.Token.createInitAccountInstruction(config_1.TOKEN_PROGRAM_ID, config_1.WRAPPED_SOL_MINT, account, payer));
    cleanupInstructions.push(spl_token_1.Token.createCloseAccountInstruction(config_1.TOKEN_PROGRAM_ID, account, payer, payer, []));
    return account;
}
exports.ensureSplAccount = ensureSplAccount;
function createUninitializedAccount(instructions, payer, amount, signers) {
    const account = new web3_js_1.Account();
    instructions.push(web3_js_1.SystemProgram.createAccount({
        fromPubkey: payer,
        newAccountPubkey: account.publicKey,
        lamports: amount,
        space: spl_token_1.AccountLayout.span,
        programId: config_1.TOKEN_PROGRAM_ID,
    }));
    signers.push(account);
    return account.publicKey;
}
exports.createUninitializedAccount = createUninitializedAccount;
function getOrCreateAssociatedTokenAccount(connection, instructions, payer, mint, owner) {
    return __awaiter(this, void 0, void 0, function* () {
        const associatedTokenAccount = yield spl_token_1.Token.getAssociatedTokenAddress(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, config_1.TOKEN_PROGRAM_ID, mint, owner);
        const accountInfo = yield getTokenAccountByAssociatedTokenAccount(connection, associatedTokenAccount);
        if (accountInfo == null) {
            instructions.push(spl_token_1.Token.createAssociatedTokenAccountInstruction(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, config_1.TOKEN_PROGRAM_ID, mint, associatedTokenAccount, owner, owner));
        }
        return associatedTokenAccount;
    });
}
exports.getOrCreateAssociatedTokenAccount = getOrCreateAssociatedTokenAccount;
function createUninitializedObligationAccount(instructions, payer, amount, signers, lendingProgramID) {
    const account = new web3_js_1.Account();
    instructions.push(web3_js_1.SystemProgram.createAccount({
        fromPubkey: payer,
        newAccountPubkey: account.publicKey,
        lamports: amount,
        space: models_1.ObligationLayout.span,
        programId: lendingProgramID,
    }));
    signers.push(account);
    return account.publicKey;
}
exports.createUninitializedObligationAccount = createUninitializedObligationAccount;
function createUninitializedMiningAccount(instructions, lendingProgramID, payer, amount, signers) {
    const account = new web3_js_1.Account();
    instructions.push(web3_js_1.SystemProgram.createAccount({
        fromPubkey: payer,
        newAccountPubkey: account.publicKey,
        lamports: amount,
        space: mining_1.MiningLayout.span,
        programId: lendingProgramID,
    }));
    signers.push(account);
    return account.publicKey;
}
exports.createUninitializedMiningAccount = createUninitializedMiningAccount;
// TODO: check if one of to accounts needs to be native sol ... if yes unwrap it ...
function findOrCreateAccountByMint(connection, payer, owner, instructions, cleanupInstructions, mint, // use to identify same type
signers, account) {
    return __awaiter(this, void 0, void 0, function* () {
        let toAccount;
        if (account && !account.info.isNative) {
            toAccount = account.pubkey;
        }
        else {
            toAccount = yield getOrCreateAssociatedTokenAccount(connection, instructions, payer, mint, owner);
            if (mint.equals(config_1.WRAPPED_SOL_MINT)) {
                cleanupInstructions.push(spl_token_1.Token.createCloseAccountInstruction(config_1.TOKEN_PROGRAM_ID, toAccount, payer, payer, []));
            }
        }
        return toAccount;
    });
}
exports.findOrCreateAccountByMint = findOrCreateAccountByMint;
function getTokenAccountByAssociatedTokenAccount(connection, tokenAccountID) {
    return __awaiter(this, void 0, void 0, function* () {
        const lpSupplyAccountInfo = yield connection.getAccountInfo(tokenAccountID);
        if (lpSupplyAccountInfo) {
            return (0, models_1.deserializeAccount)(lpSupplyAccountInfo.data);
        }
    });
}
